import { useEffect } from 'react';

import { UNKNOWN_BRAND_ID } from '@/modules/brands/constants';
import { everythingElseId } from '@/modules/categories/constants';
import { useGroupsById } from '@/modules/categories/useGroupsById';
import { addYouMightBeIntoItemToLocalStorage } from '@/modules/product/helpers/addYouMightBeIntoItemToLocalStorage';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

export function useAddBrandCategoryToLocalStorage() {
  const { data: productBasic } = useProductBySlugBasicPDP();
  const { data: productExtended } = useProductBySlugExtendedPDP();
  const { data: groupsByIdRes } = useGroupsById();

  const { brand_id } = productBasic || {};
  const { attributes } = productExtended || {};
  const { product_type, group, gender, is_kids } = attributes || {};

  const groupsById = groupsByIdRes?.data || {};
  const hasGroupsData = Object.keys(groupsById).length > 0;
  const isOtherDepartment =
    group && groupsById?.[group]?.department?.includes(everythingElseId);
  const isOtherBrand = brand_id === UNKNOWN_BRAND_ID;
  const shouldUpdateBrandCategoryLocalStorage =
    group && brand_id && hasGroupsData && !isOtherDepartment && !isOtherBrand;

  useEffect(() => {
    if (shouldUpdateBrandCategoryLocalStorage) {
      addYouMightBeIntoItemToLocalStorage({
        gender,
        brandId: brand_id,
        groupId: group,
        isKids: Boolean(is_kids),
        productType: product_type,
      });
    }
  }, [shouldUpdateBrandCategoryLocalStorage]);
}
